import { render, staticRenderFns } from "./assetSelector.vue?vue&type=template&id=24b3d3c3"
import script from "./assetSelector.vue?vue&type=script&lang=js"
export * from "./assetSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports